import React from "react";
import { Controller, useFormContext } from "react-hook-form";

const formatPhoneNumber = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/\D+/g, "").slice(0, 11);
  let formattedNumber = "";

  if (cleaned.startsWith("02")) {
    if (cleaned.length <= 2) {
      formattedNumber = cleaned;
    } else if (cleaned.length <= 5) {
      formattedNumber = `${cleaned.slice(0, 2)}-${cleaned.slice(2)}`;
    } else if (cleaned.length <= 9) {
      formattedNumber = `${cleaned.slice(0, 2)}-${cleaned.slice(2, cleaned.length - 4)}-${cleaned.slice(-4)}`;
    } else {
      formattedNumber = `${cleaned.slice(0, 2)}-${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
    }
  } else if (cleaned.startsWith("1")) {
    formattedNumber = cleaned;
  } else {
    if (cleaned.length <= 3) {
      formattedNumber = cleaned;
    } else if (cleaned.length <= 6) {
      formattedNumber = `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    } else if (cleaned.length <= 10) {
      formattedNumber = `${cleaned.slice(0, 3)}-${cleaned.slice(3, cleaned.length - 4)}-${cleaned.slice(-4)}`;
    } else {
      formattedNumber = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
    }
  }

  return formattedNumber;
}

const PhoneInput = ({ name, placeholder, className, ...rest }) => {
  const { control } = useFormContext();

  return (
    <>
      <Controller
        control={control}
        name={name}
        defaultValue=""
        render={({ field }) => (
          <input
            type="text"
            placeholder={placeholder}
            maxLength={13}
            value={field.value}
            onChange={(e) => {
              const formatted = formatPhoneNumber(e.target.value);
              field.onChange(formatted);
            }}
            className={` ${className}`}
            {...rest}
          />
        )}
      />
    </>
  );
};

export default PhoneInput;
